import { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router";
import { PartnerApi } from "../../api/partner.api";
import { useTranslation } from "../../hooks/useTranslation";

function Registration() {
  const { t } = useTranslation();
  const [company_ic, setCompanyIC] = useState("");
  const [login, setLogin] = useState("");
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [loginNeeded, setLoginNeeded] = useState(false);
  const handleRegistration = () => {
    const result = PartnerApi.registerUser({ company_ic, login });
    result.then((result) => {
      setLoginNeeded(false);
      if ("error" in result) {
        if ("loginNeeded" in result) {
          setError(
            t("auth.companyNoAdmin", { companyName: result.company?.name })
          );
          setLoginNeeded(true);
        } else {
          setError(result.error);
        }
        return;
      } else {
        if ("message" in result) {
          if ("admins" in result) {
            setMessage(
              t("auth.companyHasAdmin", {
                companyName: result.company?.name,
                admins: result.admins
                  .map((admin) => `${admin.jmeno} ${admin.prijmeni}`)
                  .join(", ")
              })
            );
          } else {
            setMessage(result.message);
          }
        }
        setError(null);
        return;
      }
    });
  };
  return (
    <>
      <div className="d-flex flex-column flex-lg-row flex-column-fluid">
        <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
          <div className="d-flex flex-center flex-column flex-lg-row-fluid">
            <div className="w-lg-500px p-10 card">
              <div className="text-center mb-11">
                <img src="/assets/media/logo-exn.png" />
                <h1 className="text-gray-500 fw-bolder mb-3 mt-6">
                  {t("auth.userRegistration")}
                </h1>
              </div>
              {error != null && <p className="text-danger">{error}</p>}

              {message ? (
                <div className="alert alert-success">{message}</div>
              ) : (
                <>
                  <div className="fv-row mb-8">
                    <input
                      type="text"
                      placeholder={t("auth.organizationId")}
                      name="company_ic"
                      defaultValue={company_ic}
                      onChange={(e) => setCompanyIC(e.target.value)}
                      className="form-control bg-transparent"
                    />
                  </div>
                  {loginNeeded && (
                    <div className="fv-row mb-8">
                      <input
                        type="text"
                        placeholder={t("auth.yourEmail")}
                        name="login"
                        defaultValue={login}
                        onChange={(e) => setLogin(e.target.value)}
                        className="form-control bg-transparent"
                      />
                    </div>
                  )}
                  <div className="d-grid mb-10">
                    <button
                      type="submit"
                      id="kt_sign_in_submit"
                      className="btn btn-primary"
                      disabled={!company_ic || company_ic === ""}
                      onClick={handleRegistration}
                    >
                      {t("auth.nextStep")}
                    </button>
                  </div>
                </>
              )}
              <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
                <NavLink to={"/"} className="link-primary">
                  {t("auth.backToLogin")}
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Registration;
